import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {NationalDrugIntegrationDTO} from '../models/national-drug/NationalDrugIntegrationDTO';

@Injectable({
  providedIn: 'root'
})
export class ExternalDrugDataService {
  private url: string = environment.baseIgnUrl + '/medprax/products';

  constructor(private httpClient: HttpClient) {
  }

  getListOfProductsByNappiCode(nappiCode: string): Observable<NationalDrugIntegrationDTO[]> {
    // Note: nappiCode= or nappiCode endpoint will throw an error so explicitly pass null if nappiCode is not present to get empty []
    const url = `${this.url}?fieldName=nappiCode&value=${nappiCode ? nappiCode : null}`;
    return this.httpClient.get<NationalDrugIntegrationDTO[]>(url);
  }

  getListOfProductsByAtcCode(atcCode: string): Observable<NationalDrugIntegrationDTO[]> {
    const url = `${this.url}?fieldName=atcLevel5Code&value=${atcCode ? atcCode : null}`;
    return this.httpClient.get<NationalDrugIntegrationDTO[]>(url);
  }
}
